import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { format } from 'date-fns';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import useQuery from '../../hooks/useQuery';

import Card from './Card';
import Text from '../../components/Text';
import Input from '../../components/Input';
import Selects from '../../components/Select';
import Button from '../../components/Button';
import DatePicker from '../../components/DatePicker';
import { useSnackbar } from '../../components/Snackbar';
import InfiniteScroll from '../../components/InfiniteScroll';
import establishmentStore from '../../store/establishment';

import * as Controller from './controller';

const cpfMask = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
];

export default function MyTransactions() {
  const query = useQuery();
  const history = useHistory();
  const snackbar = useSnackbar();

  const [cpf, setCpf] = useState();
  const [type, setType] = useState();
  const [endDate, setEndDate] = useState();
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState();
  const [transactions, setTransactions] = useState([]);

  const currentEstablishment = establishmentStore(state => state.establishment);

  const [pagination, setPagination] = useState({
    lastPage: 1,
    currentPage: 1,
    total: 0,
  });

  function fetchTransactions() {
    Controller.getTransactions(pagination.currentPage, {
      cnpj: currentEstablishment?.cgccpf?.replace(/[^\d]+/g, ''),
      finalFilter: query.toString(),
      setTransactions,
      setLoading,
      setPagination,
      snackbar,
    });
  }

  function applyQueryParameters() {
    const queryParams = query.toString();
    history.replace({ search: queryParams });
    setPagination({
      lastPage: 1,
      currentPage: 1,
      total: 0,
    });
    fetchTransactions();
  }

  useEffect(() => {
    if (currentEstablishment) fetchTransactions();
  }, [currentEstablishment]);

  function formatDate(date) {
    const [day, month, year] = date.split('/');
    return format(
      new Date(`${Number(year)}/${Number(month)}/${Number(day)}`),
      'yyyy-MM-dd'
    );
  }

  return (
    <>
      <Text color="#fff" type="header">
        Pontos em{' '}
        <Text
          color="#464E5F"
          type="header"
          style={{ fontWeight: '600', textDecoration: 'underline' }}
        >
          {currentEstablishment?.social_name}
        </Text>
      </Text>
      <Row>
        <Col xs={12} md={3}>
          <DatePicker
            value={startDate}
            onChange={e => {
              setStartDate(e.target.value);
              if (e.target.value && e.target.value.length === 10) {
                query.set('startDate', formatDate(e.target.value));
              } else query.delete('startDate');
            }}
            label={<Text color="white">Período de</Text>}
          />
        </Col>
        <Col xs={12} md={3}>
          <DatePicker
            value={endDate}
            onChange={e => {
              setEndDate(e.target.value);
              if (e.target.value && e.target.value.length === 10)
                query.set('endDate', formatDate(e.target.value));
              else query.delete('endDate');
            }}
            label={<Text color="white">Até</Text>}
          />
        </Col>
        <Col xs={12} md={2}>
          <Selects
            label={<Text color="white">Tipo da transação</Text>}
            value={type}
            onChange={v => {
              setType(v);
              if (v) query.set('type', v.value);
              else query.delete('type');
            }}
            options={[
              { label: 'Crédito', value: 'credit' },
              { label: 'Débito', value: 'debit' },
            ]}
          />
        </Col>
        <Col xs={12} md={3}>
          <Input
            label={<Text color="white">CPF</Text>}
            value={cpf}
            onChange={e => {
              setCpf(e.target.value);
              if (e.target.value)
                query.set('cpf', e.target.value.replace(/[^\d]+/g, ''));
              else query.delete('cpf');
            }}
            masked
            mask={cpfMask}
          />
        </Col>
        <Col className="mt-2" xs={12} md={1}>
          <Button onClick={() => applyQueryParameters()} className="mt-4">
            <Text clickable>Filtrar</Text>
          </Button>
        </Col>
      </Row>
      <InfiniteScroll
        loading={loading}
        data={transactions}
        renderItem={item => <Card myTransaction={item} />}
        onEndReach={() => {
          Controller.getTransactions(pagination.currentPage + 1, {
            cnpj: currentEstablishment.cgccpf.replace(/[^\d]+/g, ''),
            finalFilter: query.toString(),
            setTransactions,
            setLoading,
            setPagination,
            snackbar,
          });
        }}
        hasMore={pagination.currentPage < pagination.lastPage}
        scrollThreshold={0.7}
      />
    </>
  );
}
